export const menuItems = [];
